export function checkResponse(resp: Response) {
    if (resp.ok) {
        return resp.json();
    } else {
        return Promise.reject("Error on fetch(): " + resp.status)
    }
}

export function deleteCookie(name: string) {
    setCookie(name, "", { expires: -1, path: '/' });
}

export function getCookie(name: string): string {
    const matches = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
    );
    return matches ? decodeURIComponent(matches[1]) : "";
}

export function setCookie(name: string, value: string, props?: any) {
    props = props || {};
    let exp = props.expires;
    if (typeof exp == 'number' && exp) {
        const d = new Date();
        d.setTime(d.getTime() + exp * 1000);
        exp = props.expires = d;
    }
    if (exp && exp.toUTCString) {
        props.expires = exp.toUTCString();
    }
    value = encodeURIComponent(value);
    let updatedCookie = name + '=' + value;
    for (const propName in props) {
        updatedCookie += '; ' + propName;
        const propValue = props[propName];
        if (propValue !== true) {
            updatedCookie += '=' + propValue;
        }
    }
    document.cookie = updatedCookie;
}

export function textFromStatus(status: string) {
    switch (status) {
        case "created":
            return "Создан";
        case "pending":
            return "Готовится";
        case "done":
            return "Выполнен";
        default:
            return "Status: Not defined";
    }
}